import React, { useEffect, useState } from "react";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HeaderTitle } from "../../customComponents/Headers/HeaderTitle";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { Spinner } from "../../Spinner";
import moment from "moment";

export const FormatoTodosLosDetalles = ({ hideSidebar, unidad, viaje }) => {
  // Cuando se seleccione una unidad o un viaje diferente al actual se manda a ejecutar esta función
  const {
    getBitacoraViaje,
    getTiendasViaje,
    getTripulacionViaje,
    getOperadorViaje,
  } = useUnidades();
  useEffect(() => {
    if (!viaje.viaje_id) return;
    getInfo(viaje.viaje_id);
  }, [unidad, viaje]);

  const [operador, setOperador] = useState({});
  const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
  const [tripulacion, setTripulacion] = useState([]);
  const [bitacora, setBitacora] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfo = async (viaje_id) => {
    setLoading(true);
    let resp = await getBitacoraViaje(viaje_id);
    if (resp.ok) setBitacora([...resp.bitacora]);

    resp = await getTiendasViaje(viaje_id);
    if (resp.ok) setTiendasSeleccionadas([...resp.rutas]);

    resp = await getTripulacionViaje(viaje_id);

    if (resp.ok) setTripulacion([...resp.tripulantes]);

    resp = await getOperadorViaje(viaje_id);

    if (resp.ok) setOperador({ ...resp });
    setLoading(false);
  };
  return (
    <div>
      {loading && <Spinner />}
      <HeaderTitle className="card-header" id="card-header">
        Todos los detalles del viaje
        <i className="icono-cerrar">
          <FontAwesomeIcon
            onClick={() => {
              hideSidebar();
            }}
            icon={faXmark}
          />
        </i>
      </HeaderTitle>

      <div className="ibox float-e-margins card-body" style={{overflowY: "scroll", maxHeight : "600px"}}>
        <div className="ibox-content">
          <div className="p-l-10">
            <div className="pull-right text-right"></div>
            <p>
              <b style={{fontSize: "15px"}}>ECO: &nbsp;</b>
              {unidad.unidad_numero}
              <br />
            </p>
          </div>
          <hr />

          <div className="p-l-10">
            <div className="pull-right text-right"></div>
            <p>
              <small style={{fontSize: "15px"}}>
                <b>DESTINO(S)</b>
              </small>
              <br />
              {tiendasSeleccionadas.map((x) => {
                return (
                  <label style={{fontSize: "13px"}} key={x.tienda_id}>{x.tienda.tienda_nombre}</label>
                );
              })}
            </p>
          </div>
          <hr />

          <div className="p-l-10">
            <div className="pull-right text-right"></div>
            <p>
              <small style={{fontSize: "15px"}}>
                <b>OPERADOR</b>
              </small>
              <br />
              <p style={{fontSize: "13px"}}>
              {operador.nombre_completo}
              </p> 
              <br />
              <label>
                <a
                  href={`tel:+52${operador.telefono}`}
                  className="text-success"
                  style={{fontSize: "13px"}}
                >
                  {operador.telefono || "Sin número telefónico"}
                </a>
              </label>
            </p>
          </div>
          <hr />

          <div className="p-l-10">
            <div className="pull-right text-right"></div>
            <p>
              <small style={{fontSize: "15px"}}>
                <b>TRIPULACIÓN</b>
              </small>
              {tripulacion.length > 0 ? (
                tripulacion.map((x) => {
                  return (
                    <div key={x.tripulante_id}>
                      <label>
                        {x.tripulante
                          ? x.tripulante.nombre_completo
                          : "Desconocido"}
                      </label>
                      <br />
                      <label>
                        <a
                          href={`tel:+52${x.tripulante.telefono}`}
                          className="text-success"
                        >
                          {x.tripulante.telefono || "Sin número telefónico"}
                        </a>
                      </label>
                    </div>
                  );
                })
              ) : (
                <div>
                  <label style={{fontSize: "13px"}}>Sin tripulante</label>
                  <br />
                  <label>---</label>
                </div>
              )}
            </p>
          </div>
          <hr />

          <div className="row">
            <div className="col-sm-6 text-left m-t-5">
              <p>
                <b style={{ fontSize: "15px"}}>SALIDA</b>
                <br />
                <small style={{fontSize: "13px"}}>
                  {viaje.fecha_hora_salida &&
                    viaje.fecha_hora_salida.substring(0, 10)}{" "}
                </small>
                <p className="text-navy" style={{ lineHeight: "15px" }}>
                  <strong style={{fontSize: "13px"}}>
                    {viaje.fecha_hora_salida &&
                      viaje.fecha_hora_salida.substring(11, 16)}
                  </strong>
                </p>
              </p>
            </div>
            <div className="col-sm-6 text-left m-t-5">
              <p>
                <b style={{ fontSize: "15px"}}>LLEGADA</b>
                <br />
                <small style={{fontSize: "13px"}}></small>
                <p className="text-navy" style={{ lineHeight: "15px" }}>
                  <strong style={{fontSize: "13px"}}>
                    {unidad.viajes.fecha_hora_regreso
                      ? unidad.viajes.fecha_hora_regreso
                      : "Sin información"}
                  </strong>
                </p>
              </p>
            </div>
          </div>
          <hr />
          <div className="p-l-10">
            <div className="pull-right text-right"></div>
            <p>
              <b style={{textAlign: "center", fontSize: "18px"}}>BITACORA DE VIAJE</b>
              <br />
              <br />
              {bitacora.map((x, index) => {
                return (
                  <>
                    <p key={ index }>
                      <i
                        className={
                          x.status.icon ? x.status.icon : "fa-solid fa-question"
                        }
                        style={{
                          backgroundColor: x.status.color,
                          borderRadius: "50%",
                          padding: "8px",
                          fontSize: "12px",
                        }}
                        title={x.notas}
                      ></i>
                      <strong style={{ fontSize: "15px"}}>&nbsp;{x.status.nombre}</strong>
                      <br />
                      <small style={{fontSize: "13px"}}>
                        {x.notas ? x.notas : "Sin comentarios"}
                      </small>
                      <br />
                      <small style={{ fontStyle: "italic", fontSize: "13px" }}>
                        {moment(x.bitacora_fecha_hora).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      </small>
                    </p>
                  </>
                );
              })}
              <br />
              {/* <small className="m-r">
                <b>Bitacora de viaje</b>
              </small> */}
            </p>
          </div>
          <hr />
        </div>
      </div>

      {/* <code>{JSON.stringify(unidad)}</code>
      <hr></hr>
      <code>{JSON.stringify(viaje)}</code> */}
    </div>
  );
};
